import { Injectable, signal } from '@angular/core';

/**
 * Holds draft input text per client session so it persists when switching
 * between Client Chat and other tabs (e.g. Profile). Scoped to My Clients layout.
 */
@Injectable()
export class ClientChatDemoStateService {
  private _drafts = signal<Record<string, string>>({});

  getDraft(sessionId: string): string {
    return this._drafts()[sessionId] ?? '';
  }

  setDraft(sessionId: string, value: string): void {
    this._drafts.update((prev) => ({ ...prev, [sessionId]: value }));
  }

  clearDraft(sessionId: string): void {
    this._drafts.update((prev) => {
      const next = { ...prev };
      delete next[sessionId];
      return next;
    });
  }

  /** Read-only signal for reactive binding; component can use computed from this. */
  readonly drafts = this._drafts.asReadonly();
}
